export type TextType = 'text' | 'heading' | 'tag';
export type TextSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export default function useTextSize(size: TextSize, type: TextType = 'text') {
  const sizeToRegularFontMap: Readonly<Record<TextSize, string>> = {
    '2xl': 'text-t0 md:text-t0-mobile',
    xl: 'text-t1 md:text-t1-mobile',
    lg: 'text-t2 md:text-t2-mobile',
    md: 'text-t3 md:text-t3-mobile',
    sm: 'text-t4 md:text-t4-mobile',
    xs: 'text-t5 md:text-t5-mobile',
  };
  const sizeToHeadingFontMap: Readonly<Record<TextSize, string>> = {
    '2xl': 'text-h0 md:text-h0-mobile',
    xl: 'text-h1 md:text-h1-mobile',
    lg: 'text-h2 md:text-h2-mobile',
    md: 'text-h3 md:text-h3-mobile',
    sm: 'text-h4 md:text-h4-mobile',
    xs: 'text-h5 md:text-h5-mobile',
  };
  const sizeToTagFontMap: Readonly<Partial<Record<TextSize, string>>> = {
    md: 'text-up1',
    sm: 'text-up2',
  };
  const sizeToBulletWidthMap: Readonly<Record<TextSize, string>> = {
    '2xl': '4.5rem',
    xl: '2.875rem',
    lg: '2.25rem',
    md: '1.875rem',
    sm: '1.5rem',
    xs: '1.25rem',
  };

  const regularFont = computed(() => {
    return sizeToRegularFontMap[size];
  });
  const headingFont = computed(() => {
    return sizeToHeadingFontMap[size];
  });
  const tagFont = computed(() => {
    return sizeToTagFontMap[size];
  });

  const font = computed(() => {
    switch (type) {
      case 'heading': {
        return headingFont.value;
      }
      case 'tag': {
        return tagFont.value;
      }
      default: {
        return regularFont.value;
      }
    }
  });

  const bulletWidth = computed(() => {
    return sizeToBulletWidthMap[size];
  });

  return {
    font,
    bulletWidth,
  };
}
